import { useTranslation } from 'react-i18next';

import type { AllStatusType } from '../../types';

const STATUS_COLOR = (type?: StatusTextTypes) => ({
  not_send: 'bg-gray-status text-dark-blue',
  analysis: 'bg-orange-status text-dark-blue',
  paused: 'bg-orange-status-pause text-white',

  tobe_scheduled: 'bg-pink-status text-white',
  script_upload: 'bg-gray-status text-dark-blue',
  script_validation: 'bg-influentia-light-blue text-dark-blue',
  preview_upload: 'bg-gray-status text-dark-blue',
  preview_validation: 'bg-influentia-light-blue text-dark-blue',
  scheduled: 'bg-purple-status text-white',
  published: 'bg-green-status text-dark-blue',

  upload_pending: 'bg-gray-status text-dark-blue',
  internal_validation: 'bg-influentia-yellow text-dark-blue',
  external_validation: 'bg-influentia-light-blue text-dark-blue',
  modification_pending: 'bg-gray-status text-dark-blue',
  validated: 'bg-green-status text-dark-blue',
  old: 'bg-gray-status text-dark-blue',

  // Invoice
  payment_pending: 'bg-influentia-light-blue text-black',
  paid:
    type === 'brandInvoice'
      ? 'bg-blue-status text-white'
      : 'bg-green-status text-dark-blue',

  // Campaña General
  active: 'bg-blue-status text-white',
  facturation: 'bg-violet-status text-white',
  pending: 'bg-gray-status text-dark-blue',
  declined: 'bg-red-status text-white',
  finished: 'bg-green-status text-dark-blue',
  canceled: 'bg-red-status text-white',

  // brand invoice
  pending_billing: 'bg-gray-status text-dark-blue',
  pending_payment: 'bg-influentia-light-blue text-black',
  delayed: 'bg-red-status text-white',
  // paid added above
  // finished added above

  // user invoice
  // pending-billing added above
  pending_brand_payment: 'bg-orange-status text-dark-blue',
  // pending-payment added above
  // delayed added above
  // paid added above

  // proposal
  in_contact: 'bg-gray-status text-dark-blue',
  content_proposal: 'bg-dark-blue text-white',
  contract_signing: 'bg-violet-status text-white',
  rejected: 'bg-red-status text-white',

  // contract
  contract_pending: 'bg-gray-status text-dark-blue',
  contract_signed: 'bg-green-status text-dark-blue',
});

type StatusTextTypes =
  | 'campaign'
  | 'influencer'
  | 'content'
  | 'invoices'
  | 'action'
  | 'brandInvoice'
  | 'userInvoice'
  | 'proposal'
  | 'contract';
interface StatusTextProps {
  status: AllStatusType;
  extraClassnames?: string;
  type?: StatusTextTypes;
}

export const StatusText = ({
  status,
  extraClassnames,
  type,
}: StatusTextProps) => {
  const { t } = useTranslation('common');
  return (
    <div
      className={`h-[24px] text-sm  w-max px-3 rounded-[4px] flex items-center justify-center ${extraClassnames} ${STATUS_COLOR(type)[status as keyof typeof STATUS_COLOR]}`}
    >
      {t(`${type}Status.${status}`)}
    </div>
  );
};
